import api from "@/api";
import i18n from "@/i18n";

const { t } = i18n.global;

export default {
  state: {
  },
  getters: {
  },
  mutations: {
  },
  actions: {
    terminatePolicy: (
      _,
      { customerId, isDoubleCoverage, text, terminationServices }
    ) =>
      api({ requiresAuth: true }).post("/v1/terminations", {
        customer_id: customerId,
        comment: text,
        double_coverage: isDoubleCoverage,
        termination_services: terminationServices,
      }),

    deleteTerminationService: async ({ dispatch }, serviceId) => {
      try {
        await api({ requiresAuth: true }).delete(
          `/v1/termination-services/${serviceId}`
        );
      } catch (err) {
        dispatch("showToast", {
          type: "error",
          message: err.response?.data?.message || t("messages.failedToDeleteService")
        });
      }
    },

    updateTerminationComment: async ({ dispatch }, { terminationId, comment }) => {
      try {
        await api({ requiresAuth: true }).patch(
          `/v1/terminations/${terminationId}/comments`,
          {
            comment,
          }
        );
      } catch (err) {
        dispatch("showToast", {
          type: "error",
          message: err.response?.data?.message || t("messages.failedToUpdateComment")
        });
      }
    },

    uploadTerminationFiles: async ({ dispatch }, { terminationId, files }) => {
      const formData = new FormData();
      files.forEach((file) => {
        formData.append("termination_files[]", file);
      });
      try {
        await api({ requiresAuth: true }).post(
          `/v1/terminations/${terminationId}/files`,
          formData,
          {
            headers: {
              "Content-Type": "multipart/form-data",
            },
          }
        );
      } catch (err) {
        dispatch("showToast", {
          type: "error",
          message: err.response?.data?.message || t("messages.failedToUploadFiles")
        });
      }
    },
 
    updateTermination: async ({ dispatch }, { terminationId, customerId, isDoubleCoverageId, text, terminationServices }) => {
      try {
        await api({ requiresAuth: true }).patch(`/v1/terminations/${terminationId}`, {
          customer_id: customerId,
          comment: text,
          double_coverage: isDoubleCoverageId,
          termination_services: terminationServices,  
        });
      } catch (err) {
        dispatch("showToast", {
          type: "error",
          message: err.response?.data?.message || t("messages.failedToUpdateTermination")
        });
        throw err;
      }
    },
     
  },
};
